(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.transparent = this.hasAttribute("data-transparent");
      this.sticky = this.hasAttribute("data-sticky");
      this.selectors = {
        announcementBar: ".shopify-section-announcement-bar",
      };
      this.announcementBarheight = 0;

      this.transparent && document.body.classList.add('transparent-header')
    }

    connectedCallback() {
      ["scroll", "load", "resize"].forEach((event) =>
        window.addEventListener(event, (event) => {
          this.updateHeaderOffsetVariables();
          this.handleTransparent();
          this.checkOverflowSubmenus();
          if(this.transparent) this.offsetMainContent();
        })
      );

      if (this.hasAttribute('data-design-mode') && this.transparent) {
        window.addEventListener('shopify:section:load', (event) => {
          document.querySelector('#MainContent').style.marginTop = 0;

          // delay until styles are loaded
          setTimeout(() => {
            this.offsetMainContent();
          }, 1000);
          return;
        })
      }

      if (!this.transparent) return;
      this.offsetMainContent();
    }

    offsetMainContent() {
      document.querySelector(
        "#MainContent"
      ).style.marginTop = `-${this.offsetHeight  * 0.1}rem`;
    }

    handleTransparent() {
      const transparentAndSticky = this.transparent && this.sticky
      if (!transparentAndSticky) return;
      this.classList.toggle(
        "is-transparent",
        window.scrollY <= this.announcementBarHeight
      );
    }

    updateHeaderOffsetVariables() {
      const announcementBar = document.querySelector(
        this.selectors.announcementBar
      );
      this.announcementBarHeight = announcementBar
        ? announcementBar.offsetHeight
        : 0;
      const headerHeight = this.transparent ? 0 : this.offsetHeight;
      const headerOffset = this.announcementBarHeight + headerHeight;
      // Header height regardless of whether it's transparent or not.
      const transparentHeaderOffset = this.announcementBarHeight + this.offsetHeight;

      document.documentElement.style.setProperty(
        "--header-offset",
        `${headerOffset * 0.1}rem`
      );

      document.documentElement.style.setProperty(
        "--header-offset-with-transparent",
        `${transparentHeaderOffset * 0.1}rem`
      );

      const headerBottomPosition = this.getBoundingClientRect().bottom * 0.1;
      document.documentElement.style.setProperty(
        "--header-dropdown-max-height",
        `calc(100vmin - ${headerBottomPosition}rem)`
      );
    }

    checkOverflowSubmenus() {
      const containerBounderie =
        this.querySelector('[data-container]').getBoundingClientRect().width;

      this.querySelectorAll('[data-nav-sublinks]').forEach(submenu => {
        submenu.closest('[data-nav-dropdown]').classList.remove('is-overflowing');
        const [submenuLeft, submenuRight] = [
          submenu.getBoundingClientRect().left,
          submenu.getBoundingClientRect().right
        ];
        const submenuIsOverflowing =
          submenuLeft > containerBounderie || submenuRight > containerBounderie;
        if (submenuIsOverflowing) {
          submenu.closest('[data-nav-dropdown]')
            .classList.add('is-overflowing')
        }
      })
    }
  }

  customElements.define("sticky-header", StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["school-spirit-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spirit-slideshow')) {
    customElements.define('spirit-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => slide.classList.toggle('is-active', position === this.index));
        this.dots.forEach((dot, position) => {
          dot.classList.toggle('is-active', position === this.index);
          if (position === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      start() {
        if (this.paused || this.timer) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), 5200);
      }
      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terrific-tuesdays-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('terrific-slideshow')) {
    customElements.define('terrific-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide], .tt-slide')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.slides.length < 1) return;
        this.slides.forEach((slide, position) => slide.classList.toggle('is-active', position === 0));
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => slide.classList.toggle('is-active', position === this.index));
        this.dots.forEach((dot, position) => {
          dot.classList.toggle('is-active', position === this.index);
          if (position === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      start() {
        if (this.paused || this.slides.length < 2) return;
        this.stop();
        this.timer = window.setInterval(() => this.show(this.index + 1), 4500);
      }
      stop() {
        if (this.timer) window.clearInterval(this.timer);
      }
    });
  }

  if (!customElements.get('terrific-release-filter')) {
    customElements.define('terrific-release-filter', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-release-search]');
        this.cards = [...this.querySelectorAll('[data-release-card]')];
        this.empty = this.querySelector('[data-empty-message]');
        this.input?.addEventListener('input', () => this.filter());
      }
      filter() {
        const query = this.input.value.trim().toLowerCase();
        let visible = 0;
        this.cards.forEach(card => {
          const matches = !query || card.dataset.title.includes(query);
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        if (this.empty) this.empty.hidden = visible !== 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
